import {atom, selector} from 'recoil';

const peopleState = atom({
  key: 'peopleState',
  default: [],
});

export const sortedPeopleState = selector({
  key: 'sortedPeopleState',
  get: ({get}) => {
    const people = get(peopleState);

    return [...people]
    .sort((a, b) => b.timestamp - a.timestamp)
    .slice(0, 200);
  },
});

export default peopleState;
